<template>
  <div class="session-carousel" v-if="bannerArray && bannerArray.length">
    <div ref="carousel" class="carousel-track">
      <div
        v-for="(banner, index) in bannerArray"
        :key="index"
        class="carousel-slide"
        :style="backgroundStyle(banner.image_url)"
      >
        <div class="container">
          <h1 class="carousel-title">{{banner.title}}</h1>
          <h4 class=" text-xl-left text-white" style="max-width: 794px">{{banner.description}}</h4>
          <a :href="banner.cta_link" class="button">
            {{banner.cta_text}}
            <span class="arrow">→</span>
          </a>
        </div>
      </div>
    </div>
    <i
      v-if="currentIndex > 0"
      @click="scroll('left')"
      class="fa-solid fa-chevron-left nav-arrow left-arrow"
    />
    <i
      v-if="currentIndex < bannerArray.length - 1"
      @click="scroll('right')"
      class="fa-solid fa-chevron-right nav-arrow right-arrow"
    />
  </div>
</template>

<script>
import axios from "axios";
import config from "../../../config/constants";

export default {
  name: "HomeSessionsBanner",
  props: {
    baseColor: {
      type: String,
      default: "#1e1e1e"
    }
  },
  data() {
    return {
      currentIndex: 0,
      bannerArray: null
    };
  },
  methods: {
    async getHomepageBanner() {
      const payload = {
          user_id: this.$store.getters.user_id,
        }
      const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-homepage-banner', payload, config.options)
      if (res.data.success && res.data.banners.length) {
        this.bannerArray = res.data.banners
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
    
    scroll(direction) {
      const carousel = this.$refs.carousel;
      const cardWidth = carousel.clientWidth;
      
      if (direction === "right") {
        this.currentIndex = Math.min(this.currentIndex + 1, this.bannerArray.length - 1);
      } else {
        this.currentIndex = Math.max(this.currentIndex - 1, 0);
      }
      
      carousel.scrollTo({
        left: cardWidth * this.currentIndex,
        behavior: "smooth"
      });
    },
    
    updateCurrentIndex() {
      const carousel = this.$refs.carousel;
      const scrollLeft = carousel.scrollLeft;
      const cardWidth = carousel.clientWidth;
      
      this.currentIndex = Math.round(scrollLeft / cardWidth);
    },
    
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const later = () => {
          timeout = null;
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    backgroundStyle(bgUrl) {
      return {
        backgroundImage: `
          linear-gradient(
            to right,
            ${this.baseColor} 0%,
            ${this.baseColor} 40%,
            ${this.baseColor}CC 60%,
            transparent 100%
          ),
          url(${bgUrl})
        `,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right center"
      };
    }
  },
  mounted() {
    this.getHomepageBanner()
    
    const carousel = this.$refs.carousel;
    carousel.addEventListener("scroll", this.debouncedUpdateIndex);
  },
  beforeDestroy() {
    const carousel = this.$refs.carousel;
    carousel.removeEventListener("scroll", this.debouncedUpdateIndex);
  },
  created() {
    this.debouncedUpdateIndex = this.debounce(this.updateCurrentIndex, 100);
  },
  
};
</script>

<style scoped>
.session-carousel {
  position: relative;
  overflow: hidden;
  padding-inline: 0;
  margin-bottom: 25px;
}

.carousel-track {
  display: flex;
  transition: all 0.5s ease-in-out;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  
  &::-webkit-scrollbar {
    display: none;
  }
}

.carousel-slide {
  min-width: 100%;
  min-height: 400px;
  padding-inline: 89px;
  padding-top: 30px;
  padding-bottom: 53px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  background-size: cover;
  background-position: center;
  color: white;
  scroll-snap-align: start;
}

@media (max-width: 425px) {
  .carousel-slide {
    padding-inline: 55px; /* or whatever value you prefer */
  }
}

.carousel-title {
  font-family: "Raptor V3 Black";
  font-size: 4.5rem;
  color: #FFFFFF;
  text-align: left;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 45px;
  padding-block: 12px;
  padding-right: 15px;
  padding-left: 45px;
  background-color: #604AFF;
  color: white;
  font-weight: 900;
  font-size: 20px;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.arrow {
  font-size: 20px;
  font-weight: 900;
  background-color: #FFFFFF;
  color: black;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 5px;
}

.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0);
  color: #CACACA;
  cursor: pointer;
  border: none;
  z-index: 1;
  width: 50px;
  height: 50px;
  font-size: 50px;
  text-align: center;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0) !important;
  }
}

.left-arrow {
  left: 16px;
}

.right-arrow {
  right: 16px;
}

.nav-arrow:hover {
  background-color: rgba(31, 41, 55, 0.9);
}
</style>
